import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { useTimeZone } from '../../../../hooks'
import { FloatingTooltip } from '../../../Floating'

import { MATCH_PROVENANCE_DOT_CLASS } from './RentalPortalMatchProvenanceDot.constants'
import { getMatchProvenanceTooltip } from './RentalPortalMatchProvenanceDot.utils'

import * as styles from './RentalPortalMatchProvenanceDot.module.css'

function RentalPortalMatchProvenanceDot({ isTooltipDisabled, provenance }) {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  return provenance ? (
    <FloatingTooltip
      content={getMatchProvenanceTooltip({ provenance, t, timezone })}
      disabled={isTooltipDisabled}
    >
      <span
        className={classNames(
          styles.RentalPortalMatchProvenanceDot,
          styles[MATCH_PROVENANCE_DOT_CLASS[provenance.source]]
        )}
      />
    </FloatingTooltip>
  ) : null
}

export default RentalPortalMatchProvenanceDot
